import { IconCheck } from '@developerz/ui';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { ConnectMcpBody } from './ConnectMcpBody';
import { Spinner } from './Spinner';

// The funnel's chat-client step (epic #3629, child #3632): the same body the
// Tokens page's `<ConnectMcpPanel/>` mounts — the MCP address, a `claude mcp add`
// line and a `.mcp.json` entry — under the funnel's own wait. The BODY, not the
// Panel: this card is already titled "Connect a chat client" and so is that
// panel, so mounting the wrapper repeated one `<h2>` directly under itself.
//
// `connected` is READ off the funnel state, never off anything this component
// did: the API's fact ladder settles `mcp_connected` from the first connector
// grant, and this card's only control re-reads `/state`. A self-declared
// "I connected it" would be the caller asserting a platform-witnessed fact
// (`OnboardingEventWitness`), which is the door #2400 closed.
//
// Once the fact HAS settled the address stops rendering, and that is the point
// of the split rather than an omission: the panel exists to get a first client
// on, the confirmation is what says it took, and a second client is added from
// the Tokens page (which the footer links to) rather than from a funnel step
// the account has already left behind.

export type OnboardingMcpStepProps = {
  readonly connected: boolean;
};

export function OnboardingMcpStep(props: OnboardingMcpStepProps): JSX.Element {
  return (
    <div class="field-group onboarding__mcp">
      <Show
        when={props.connected}
        fallback={
          <>
            <p class="onboarding__waiting">
              <Spinner size="1.05rem" />
              {t('onboarding.mcp_waiting')}
            </p>
            <ConnectMcpBody />
          </>
        }
      >
        <div class="alert alert--icon" role="status">
          <IconCheck />
          <p class="alert__title">{t('onboarding.mcp_connected')}</p>
        </div>
      </Show>
    </div>
  );
}
